"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const Dog = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  d: "M8 9.6c-.882 0-1.6-.718-1.6-1.6 0-.882.718-1.6 1.6-1.6.882 0 1.6.718 1.6 1.6 0 .882-.718 1.6-1.6 1.6M8 0C3.59 0 0 3.589 0 8s3.59 8 8 8a7.95 7.95 0 0 0 4.523-1.394l-1.294-1.884A5.674 5.674 0 0 1 8 13.714 5.72 5.72 0 0 1 2.286 8 5.72 5.72 0 0 1 8 2.286 5.72 5.72 0 0 1 13.714 8v.597c0 .488-.109 1.308-.838 1.308h-.304c-.222-.009-.671-.444-.686-.662V8A3.89 3.89 0 0 0 8 4.114 3.89 3.89 0 0 0 4.115 8 3.89 3.89 0 0 0 8 11.886c.892 0 1.706-.315 2.363-.823.573.66 1.39 1.127 2.208 1.127h.305c1.84 0 3.124-1.478 3.124-3.593V8c0-4.411-3.589-8-8-8",
  className: "fill"
}));

var _default = Dog;
exports.default = _default;